import { Component, Prop, h } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

/**
 * Stats component for SignNow brand key metrics
 *
 * @product signnow
 * @version 1.0.0
 * @category metrics
 * @contentConfig Stats component for displaying key business metrics and achievements
 * @constant STATS_COUNTER_VALUE_1 - "24x" - First metric value
 * @constant STATS_COUNTER_CAPTION_1 - "Collect signatures" - First metric caption
 * @constant STATS_COUNTER_DESCRIPTION_1 - "faster" - First metric description
 * @constant STATS_COUNTER_VALUE_2 - "$30" - Second metric value
 * @constant STATS_COUNTER_CAPTION_2 - "Reduce costs by" - Second metric caption
 * @constant STATS_COUNTER_DESCRIPTION_2 - "per document" - Second metric description
 * @constant STATS_COUNTER_VALUE_3 - "40h" - Third metric value
 * @constant STATS_COUNTER_CAPTION_3 - "Save up to" - Third metric caption
 * @constant STATS_COUNTER_DESCRIPTION_3 - "per employee / month" - Third metric description
 */
@Component({
  tag: 'sn-stats-type-6',
  shadow: false,
})
export class SNStatsType6 {
  /**
   * Component constants object containing all required text constants
   */
  @Prop({ mutable: true }) constants?: Record<string, string> | string;

  componentWillLoad() {
    this.constants = parseJsonProp(this.constants);
  }

  render() {
    return (
      <stats-type-6
        counters={[
          {
            value: getConstant(this.constants, 'STATS_COUNTER_VALUE_1', '24x'),
            caption: getConstant(this.constants, 'STATS_COUNTER_CAPTION_1', 'Collect signatures'),
            description: getConstant(this.constants, 'STATS_COUNTER_DESCRIPTION_1', 'faster'),
          },
          {
            value: getConstant(this.constants, 'STATS_COUNTER_VALUE_2', '$30'),
            caption: getConstant(this.constants, 'STATS_COUNTER_CAPTION_2', 'Reduce costs by'),
            description: getConstant(this.constants, 'STATS_COUNTER_DESCRIPTION_2', 'per document'),
          },
          {
            value: getConstant(this.constants, 'STATS_COUNTER_VALUE_3', '40h'),
            caption: getConstant(this.constants, 'STATS_COUNTER_CAPTION_3', 'Save up to'),
            description: getConstant(this.constants, 'STATS_COUNTER_DESCRIPTION_3', 'per employee / month'),
          },
        ]}
        animationType="none"
        animationMode="all-at-once"
        animationDuration={600}
        counterAnimationDuration={2000}
        animationEasing="ease"
        animationDelay={200}
        align="left"
      ></stats-type-6>
    );
  }
}
